<template>
  <v-container style="padding: 15px !important;">
        <div class="DataTable">
          <v-form ref="form_modal">
            <v-layout column>
              <v-flex style="overflow: auto; font-size: 15px !important; padding: 5px !important;text-align:-webkit-center;">
                {{ text }}
              </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs12 v-if="question" style="text-align:-webkit-center;">
                    <v-btn @click="ok" class="AppButtonFilled">Potvrdi</v-btn>
                    <v-btn @click="nok" class="AppButtonOutlined">Odustani</v-btn>
                </v-flex>
                <v-flex xs12 style="text-align:-webkit-center;" v-else>
                    <v-btn @click="nok" class="AppButtonFilled">U redu</v-btn>
                </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
</template>
<script>
    export default {
        props: ["text", "question"],
        name: "AdditiveGroupItem",
        data: () => ({
    
  }),
  methods: {
      ok() {
          this.$emit("newdata", "");
      },
      nok() {
          this.$emit("close", "");
      }
  }
    
    }
</script>